import {LexicalEditor} from 'lexical';
import {useEffect, useRef} from 'react';

import {Props as RichTextAreaProps, RichTextArea} from './RichTextArea';

/**
 * Hidden Yjs → Lexical → HTML for one-shot export (e.g. version diff).
 * Uses a fast document-export preset; not for live collab.
 */
export const YjsToEditorStateConverter = ({
  yjsValue,
  onDocumentReady,
  conversionKey,
  ...props
}: {
  yjsValue: Uint8Array;
  onDocumentReady: (editor: LexicalEditor) => void;
  conversionKey?: string;
} & Omit<RichTextAreaProps, 'yjsValue' | 'onDocumentReady' | 'documentExportPreset'>) => {
  const calledRef = useRef(false);

  // Reset calledRef when conversionKey changes
  useEffect(() => {
    calledRef.current = false;
  }, [conversionKey]);

  const handleDocumentReady = (editor: LexicalEditor) => {
    if (calledRef.current) return;
    calledRef.current = true;
    onDocumentReady(editor);
  };

  return (
    <div style={{display: 'none'}}>
      <RichTextArea
        key={conversionKey}
        {...props}
        yjsValue={yjsValue}
        editable={false}
        documentExportPreset="static"
        onDocumentReady={handleDocumentReady}
      />
    </div>
  );
};
